<template>
  <!-- compose into you own markup, MyDialog.vue -->
  <a11y-vue-dialog-renderless
    v-bind="$props"
    @close="$emit('close')"
    #default="{ open, closeFn, backdropRef, dialogRef, closeRef }"
  >
    <portal :to="`a11y-vue-dialogs-${target}`" v-if="open">
      <div class="backdrop" v-bind="backdropRef.props" @click="closeFn">
        <div
          :class="classes + ' c-dialog'"
          v-bind="dialogRef.props"
          v-on="dialogRef.listeners"
        >
          <svg
            v-if="closable !== false"
            class="close"
            width="24.858"
            height="24.858"
            v-bind="closeRef.props"
            v-on="closeRef.listeners"
          >
            <path
              stroke="white"
              stroke-width="2px"
              d="M1.186 1.402l22.433 22.035M23.619 1.402L1.186 23.437"
            />
          </svg>

          <section>
            <Headline v-if="title" :size="2">{{ title }}</Headline>
            <slot></slot>
          </section>
        </div>
      </div>
    </portal>
  </a11y-vue-dialog-renderless>
</template>

<script>
import { A11yVueDialogRenderless } from "a11y-vue-dialog";
import { Portal } from "portal-vue";
import Headline from "@/components/Layout/Headline";

export default {
  name: "AppDialog",
  components: {
    Headline,
    A11yVueDialogRenderless,
    Portal,
  },
  extends: A11yVueDialogRenderless,
  props: ["open", "role", "title", "classes", "from", "closable"],
  computed: {
    target() {
      if (this.from === "icon") {
        return "menu";
      }
      return "main";
    },
  },
};
</script>

<style lang="postcss" scoped>
.backdrop {
  @apply fixed top-0 left-0 w-full h-full flex text-center content-center items-center flex-col place-content-center;
  backdrop-filter: blur(1rem) brightness(0.6);

  .c-dialog {
    @apply outline-none relative w-full;

    section {
      @apply bg-white p-8 py-24 mt-8 text-left;

      &::v-deep h2 {
        @apply mb-4;
      }
      clip-path: polygon(0% 10%, 100% 0%, 100% 100%, 0% 90%);
    }

    @screen lg {
      max-width: 40%;
    }
  }

  .close {
    @apply absolute cursor-pointer;
    right: 20px;

    @screen md {
      @apply right-0;
    }
  }
}
</style>
